import { ApiClient } from '../apiClient';
import type { BankAccount } from '../../types/bankAccount';

// Saved SEPA payer accounts (login-only). The raw IBAN goes up once on add
// and never comes back - reads are masked.
export class BankAccountsService {
  constructor(private apiClient: ApiClient) {}

  async list(): Promise<BankAccount[]> {
    return this.apiClient.get<BankAccount[]>('/user/bank-accounts');
  }

  async add(holderName: string, iban: string): Promise<BankAccount> {
    return this.apiClient.post<BankAccount>('/user/bank-accounts', {
      holderName,
      iban,
    });
  }

  async remove(id: string): Promise<boolean> {
    return this.apiClient.delete<boolean>(
      `/user/bank-accounts/${encodeURIComponent(id)}`,
    );
  }
}
